
import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'COperatorLogin',
  data () {
    return {
      loginData: {
        username: '',
        password: ''
      },
      valid: false,
      rules: [ (value: any) => !!value || 'Required' ]
    }
  },
  methods: {
    async login() {
      try {
        // @ts-ignore
        this.$refs.form.validate();
        if(this.valid) {        
          await axios.post('/api/v1/operator/login', this.loginData);
          this.$router.push('/operator-view');
        }
      } catch (error) {
        this.$store.commit('setSnackbar', { serverMessage: error.response.data.message || error.message, show: true, color: 'error' });
      }
    }
  }
})

